import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Video from './Video';
import Videolist from './Videolist';
import { useAccessCard } from '../../ContextProvider/Accesscardprovider';

const Videoviewer = () => {
  const { vcode, setVcode, setVicon } = useAccessCard();
  const location = useLocation();
  const navigate = useNavigate();
  const video = location.state || [];

  useEffect(() => {
    if (video.length > 0) {
      setVcode(video[0]);
      setVicon(video[0]?.video_link);
    }
  }, [location.key]); // rerun on location change

  return (
    <>
      <div className='btUnit'></div>
      <div className='videoviewer_container'>
        <Video videoUrl={vcode?.video_link} />
        <Videolist vidlst={video} />
      </div>
    </>
  );
};

export default Videoviewer;
